// Make sure we're importing React properly
import React from 'react';
import apiService from '../services/APIService';
import { SERVER_STATUS } from '../modules/Enumeration';

// Create the context
const APIContext = React.createContext(null);

// Export a simplified version that doesn't use hooks
export const APIProvider = ({ children }) => {
  // Create a simple value object without hooks
  const contextValue = {
    status: SERVER_STATUS.OK,
    get: (endpoint, options) => apiService.get(endpoint, options),
    post: (endpoint, data, options) => apiService.post(endpoint, data, options),
    put: (endpoint, data, options) => apiService.put(endpoint, data, options),
    patch: (endpoint, data, options) => apiService.patch(endpoint, data, options),
    delete: (endpoint, options) => apiService.delete(endpoint, options),
    requestWithRawJson: (endpoint, method, jsonData, options) => 
      apiService.requestWithRawJson(endpoint, method, jsonData, options),
    requestWithFormData: (endpoint, method, formData, options) => 
      apiService.requestWithFormData(endpoint, method, formData, options),
    requestWithParams: (endpoint, method, queryParams, data, options) => 
      apiService.requestWithParams(endpoint, method, queryParams, data, options),
    setAuthToken: (token) => apiService.setAuthToken(token),
    getBaseUrl: () => apiService.getBaseUrl(),
    cancelAllRequests: () => apiService.cancelAllRequests(),
    
  };

  return React.createElement(
    APIContext.Provider,
    { value: contextValue },
    children
  );
};

// Custom hook to use the API context
export const useAPI = () => {
  const context = React.useContext(APIContext);
  if (!context) {
    throw new Error('useAPI must be used within an APIProvider');
  }
  return context;
};

// Export the context for advanced use cases
export default APIContext;
